import React from 'react';

import { List } from '../../components';
import { ListContainer } from '../../containers';
import NoteListItem from './NoteListItem';

const NoteListRaw = ({
	items,
	refetchList,
	onClickEditNote,
}) => {
	return (
		<List
			items={items}
			listItemComponent={NoteListItem}
			customProps={{ refetchList, onClickEditNote }}
			emptyListMessage="No notes yet"
			emptyListHint="Notes added here are shown to everyone who opens this page."
		/>
	);
};

const NoteList = ListContainer(NoteListRaw);

const NoteListView = ({
	items,
	refetchList,
	onClickEditNote,
}) => {
	return (
		<NoteList
			frontEnd={true}
			items={items}
			refetchList={refetchList}
			onClickEditNote={onClickEditNote}
		/>
	);
};

export default NoteListView;
